export enum CompanyFormationStatus {
    Unknown = "Unknown",
    Accepted = "Accepted",
    Rejected = "Rejected",
    Pending = "Pending",
    Parked = "Parked",
    Failure = "Failure",
    Polled = "Polled",
}
